import React, { FC, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { makeStyles, Theme } from '@material-ui/core/styles'
import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined'

import { Box, Fab, Tooltip, Typography } from '@material-ui/core'
import { COPY_ALERT_TIMEOUT } from '../../constants/alerts'
import { useAlert } from '../../hooks'
import { AlertMsgRequisites } from '../../types'
import { copyToClipboard } from '../../utils'
import InfoIcon from '../../assets/images/icons/info_icon.svg?react'
import { capitalize } from 'lodash'

const useStyles = makeStyles((theme: Theme) => ({
  flexItem: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      alignItems: 'center',
    },
  },
  inner: {
    marginRight: theme.spacing(1.5),
    color: '#434343',
  },
  btnCopy: {
    minWidth: 15,
    minHeight: 15,
    width: 15,
    height: 15,
    marginRight: 12,
    padding: 0,
    boxShadow: 'none',
    backgroundColor: 'transparent',
    '& .MuiSvgIcon-root': {
      width: 15,
      height: 15,
      transition: `${theme.transitions.duration.complex}ms ${theme.transitions.easing.easeInOut}`,
    },
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '&:hover .MuiSvgIcon-colorPrimary': {
      color: '#276EF1',
    },
    '& .MuiSvgIcon-colorPrimary': {
      color: '#999',
    },
  },
}))

export const CopyToClipboard: FC<{
  address: string | null | undefined
  msgType: AlertMsgRequisites
}> = ({ address, msgType }) => {
  const classes = useStyles()
  const { t } = useTranslation()
  const { setAlertData } = useAlert()

  const handleCopy = useCallback(
    (value: AlertMsgRequisites) => (e: React.SyntheticEvent) => {
      e.stopPropagation()
      void copyToClipboard(`${address}`)

      setAlertData(
        {
          text: t('copiedToClipboard', { name: capitalize(value) }),
          type: 'primary',
          icon: <InfoIcon />,
        },
        COPY_ALERT_TIMEOUT,
      )
    },
    [address],
  )
  const tooltipText = `${t('copy', 'Copy')} ${msgType}`

  return (
    <Box className={classes.flexItem}>
      <Typography
        variant="body1"
        component="p"
        data-text="walletAddress"
        noWrap
        className={classes.inner}
      >
        {address}
      </Typography>
      <Fab className={classes.btnCopy} onClick={handleCopy(msgType)} data-test="copyDetails">
        <Tooltip title={tooltipText} placement="top" arrow>
          <FileCopyOutlinedIcon color="primary" />
        </Tooltip>
      </Fab>
    </Box>
  )
}
